import { privateHttp } from "@/shared/http/private-http";
import type {
    CustomerProfile,
    CustomerRegistrationDto,
    PreRegistration,
    RegisteredCustomer,
    UpdateCustomerProfileDto,
} from "../types/profile.dto";

/** POST /customer/register — cadastra um novo cliente (rota pública). */
export async function registerCustomer(
    payload: CustomerRegistrationDto
): Promise<RegisteredCustomer> {
    const { data } = await privateHttp.post<RegisteredCustomer>("/customer/register", payload);
    return data;
}

/** GET /customer/validate-cpf-cnpj/:cpfCnpj — valida o documento (rota pública). */
export async function validateCpfCnpj(cpfCnpj: string): Promise<boolean> {
    const { data } = await privateHttp.get<{ isValid: boolean }>(
        `/customer/validate-cpf-cnpj/${cpfCnpj}`
    );
    return data.isValid;
}

/**
 * GET /customer/pre-registration — o identificador digitado no login pertence a
 * um cliente que a loja importou por planilha e que ainda não definiu senha?
 * Aceita CPF/CNPJ ou e-mail (rota pública).
 */
export async function findPreRegistration(identifier: {
    cpfCnpj?: string;
    email?: string;
}): Promise<PreRegistration> {
    const { data } = await privateHttp.get<PreRegistration>("/customer/pre-registration", {
        params: identifier,
    });
    return data;
}

/** GET /customer/profile/:cpfCnpj — perfil completo do cliente autenticado. */
export async function getCustomerProfile(cpfCnpj: string): Promise<CustomerProfile> {
    const { data } = await privateHttp.get<CustomerProfile>(`/customer/profile/${cpfCnpj}`);
    return data;
}

/** PUT /customer/profile/:cpfCnpj — atualiza dados pessoais (CPF/CNPJ imutável). */
export async function updateCustomerProfile(
    cpfCnpj: string,
    payload: UpdateCustomerProfileDto
): Promise<CustomerProfile> {
    const { data } = await privateHttp.put<CustomerProfile>(`/customer/profile/${cpfCnpj}`, payload);
    return data;
}
